import { API_CONFIG, getApiUrl, getAuthHeaders } from '../config/api';
import { getWeekDateRange } from './appointmentCache';

export type GoogleCalendarPushResult = {
  pushed: number;
  skipped: number;
  deleted: number;
  errors: string[];
};

export const downloadGoogleCalendarWeek = async (
  token: string,
  date: Date,
  calendarId: string
): Promise<Response> => {
  const { start, end } = getWeekDateRange(date);
  return fetch(getApiUrl(API_CONFIG.ENDPOINTS.CALENDAR_IMPORT), {
    method: 'POST',
    headers: getAuthHeaders(token),
    body: JSON.stringify({
      startDate: start,
      endDate: end,
      calendarId,
      forceRefresh: true
    })
  });
};

export const uploadGoogleCalendarWeek = async (
  token: string,
  date: Date,
  calendarId: string
): Promise<GoogleCalendarPushResult> => {
  const { start, end } = getWeekDateRange(date);
  const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.CALENDAR_PUSH), {
    method: 'POST',
    headers: getAuthHeaders(token),
    body: JSON.stringify({ startDate: start, endDate: end, calendarId })
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Push failed (${response.status}): ${message}`);
  }

  return response.json();
};
